// src/styles/styledComponents.ts

import styled from "styled-components";
import { Button } from "antd";

// Layout container for overall structure
export const PositionRelativeContainer = styled.div`
  position: relative;
`;

// Wrapper for interactive content with toggleable interaction state
export const InteractiveContentWrapper = styled.div<{ isInteractive: boolean }>`
  padding: 5px 15px 5px 15px;
  position: relative;
  z-index: 1;
  pointer-events: ${(props) => (props.isInteractive ? "auto" : "none")};
`;

// Overlay for displaying modal or popup-like content
export const ModalOverlay = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 999; /* Overlay with high z-index */
  display: ${(props) =>
    props.isVisible ? "flex" : "none"}; /* Control visibility */
  justify-content: center;
  align-items: center;
  pointer-events: ${(props) =>
    props.isVisible ? "auto" : "none"}; /* Allow interaction if visible */
`;

// Action button that can be used to trigger actions
export const OverlayActionButton = styled(Button)`
  z-index: 1000; /* Button will be above overlay */
  pointer-events: auto; /* Allow interaction with the button */
`;

export const OverlayActionContainer = styled.div`
  z-index: 1000;
  pointer-event: auto;
`;
